import { HostListener } from '@angular/core';
import { Component, OnInit,ViewChild ,AfterViewInit } from '@angular/core';

import 'rxjs/add/operator/map';
declare var $: any;
import {AuthenticationService} from './authentication.service';

@Component({
  selector: 'app-root',
  providers: [AuthenticationService],
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  title = 'app';

  @HostListener('window:beforeunload', ['$event'])
      beforeunloadHandler(event) {
        let date : any = Date.now();
        localStorage.setItem("lastactivity", date);
  }

  @HostListener('window:unload', ['$event'])
      unloadHandler(event) {
        let date1 :any = localStorage.getItem('lastactivity');
        let date2 = Date.now();
        if (date1 !== undefined) {
         let difference = date2 - date1;
         let diff :any = ((difference) / 1000).toFixed(0);
         if (diff > 10) {
            localStorage.clear();
            //localStorage.removeItem(key);  for removing a single item
         }
        }
  }

  logout() {
    localStorage.removeItem("Id");
    localStorage.removeItem("username");
    localStorage.removeItem("userrole");   
  }

  
  
}
